// Filtre

document.addEventListener("DOMContentLoaded", function () {
    var actus = jQuery('#actualites_container');
    if (actus.length > 0) {
            ajaxActualites();
    }


    jQuery('.cat-list_item').on('click', function() {
        jQuery('.cat-list_item').removeClass('active');
        jQuery(this).addClass('active');
        ajaxActualites(jQuery(this).data('slug'), jQuery(this).data('type'))

    });

    jQuery('.collapse-tri').on('click', function() {
        jQuery('#categories-list').toggleClass('cat-list');


    });

    // Loadmore
    jQuery('.loadmore_actualites').on('click', function() {
        var button = jQuery(this);
        var buttonTextSpan = button.find('span');
        var activeCategory = jQuery('.cat-list_item.active');
        jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'loadmore_actualites',
                category: activeCategory.data('slug'),
                type: activeCategory.data('type'),
                page: loadmore_actualites_params.current_page +1,
            },
            beforeSend: function (xhr) {
                buttonTextSpan.text("Chargement..."); // change the button text, you can also add a preloader image
            },
            success: function(res) {

                if (res) {
                    jQuery('#actualites').append(res);
                    loadmore_actualites_params.current_page++;
                    button.css('pointer-events','unset');
                    buttonTextSpan.text("Voir plus d'articles");

                    var max_num_pages_posts = document.getElementById('max_num_pages_posts');

                    if (loadmore_actualites_params.current_page == max_num_pages_posts.innerText) {
                        button.css("pointer-events", "none");
                        buttonTextSpan.text("Fin des articles");
                    }

                } else {
                    button.css("pointer-events", "none");
                    buttonTextSpan.text("Fin des articles");
                }
            }
        })
    });

});

function ajaxActualites(slug = "", type="post"){
    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'html',
        data: {
            action: 'filter_actus',
            category: slug,
            type: type,
            page: 1,
        },
        beforeSend: function (xhr) {
            jQuery('.loadmore_actualites span').text("Chargement..."); // change the button text, you can also add a preloader image
        },
        success: function(res) {
            if (res) {
                jQuery('#actualites').html(res);
                loadmore_actualites_params.current_page = 1;
                jQuery('.loadmore_actualites').css('pointer-events', 'unset');
                jQuery('.loadmore_actualites span').text("Voir plus d'articles");

                var max_num_pages_posts = document.getElementById('max_num_pages_posts');
                window.location.href = "/actualites/#content";
                if (max_num_pages_posts !== null) {
                    if (loadmore_actualites_params.current_page == max_num_pages_posts.innerText) {
                        jQuery('.loadmore_actualites').css("pointer-events", "none");
                        jQuery('.loadmore_actualites span').text("Fin des articles");
                    }

                } else {
                    jQuery('.loadmore_actualites').css("pointer-events", "none");
                    jQuery('.loadmore_actualites span').text("Fin des articles");

                }
            }
        }
    })
}





